import React, { useEffect, useState } from 'react';
import { Search, ShoppingCart, Menu, X, BookOpen, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
const SHOPIFY_URL = 'https://zmw0gn-ks.myshopify.com/cart/43841787363371:1?channel=buy_button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Catálogo',
    href: '#catalogo'
  }, {
    name: 'Recomendados',
    href: '#recomendados'
  }, {
    name: 'Categorías',
    href: '#categorias'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex items-center justify-between" data-id="element-102">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-103">
            <div className="bg-indigo-600 p-2 rounded-lg" data-id="element-104">
              <BookOpen className="w-5 h-5 text-white" data-id="element-105" />
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-900" data-id="element-106">
              Global Nova Pro
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-107">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-indigo-600 transition-colors" data-id="element-108">
                {link.name}
              </a>)}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-3" data-id="element-109">
            <button className="p-2 text-slate-600 hover:text-indigo-600 transition-colors hidden sm:block" data-id="element-110">
              <Search className="w-5 h-5" data-id="element-111" />
            </button>
            <button className="p-2 text-slate-600 hover:text-indigo-600 transition-colors relative" data-id="element-112">
              <ShoppingCart className="w-5 h-5" data-id="element-113" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-indigo-600 rounded-full" data-id="element-114"></span>
            </button>

            {/* WOW Buy Button */}
            <motion.a href={SHOPIFY_URL} target="_blank" rel="noopener noreferrer" className="relative hidden sm:flex items-center gap-2 bg-indigo-600 text-white px-5 py-2.5 rounded-full text-sm font-semibold overflow-hidden group" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.97
          }} data-id="element-115">
              {/* Shimmer effect */}
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out" data-id="element-116" />
              {/* Glow ring */}
              <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-[0_0_20px_rgba(99,102,241,0.5)]" data-id="element-117" />
              <Zap className="w-4 h-4 relative z-10" data-id="element-118" />
              <span className="relative z-10" data-id="element-119">Comprar Ahora</span>
            </motion.a>

            {/* Mobile Menu Toggle */}
            <button className="p-2 text-slate-600 md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-120">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-121" /> : <Menu className="w-6 h-6" data-id="element-122" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-123">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-700 p-2 hover:bg-slate-50 rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-124">
              {link.name}
            </a>)}
          <div className="relative mt-2" data-id="element-125">
            <Search className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-126" />
            <input type="text" placeholder="Buscar libros" className="w-full bg-slate-50 border border-slate-200 rounded-full py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500" data-id="element-127" />
          </div>
          {/* Mobile Buy Button */}
          <a href={SHOPIFY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-indigo-600 text-white py-3 rounded-full text-base font-semibold hover:bg-indigo-700 transition-colors mt-2" data-id="element-128">
            <Zap className="w-5 h-5" data-id="element-129" />
            Comprar Ahora
          </a>
        </div>}
    </header>;
}